import { useContext } from 'react';
import { LiveChallengeContext } from '@/providers/LiveChallengeProvider';

export const useLiveChallenge = () => {
  const context = useContext(LiveChallengeContext);

  if (!context) {
    throw new Error('useLiveChallenge must be used within a LiveChallengeProvider.');
  }

  return context;
};
